import React from 'react'
import {
    Flex,
    Button,
    Text,
    useMultiStyleConfig,
} from '@salesforce/retail-react-app/app/components/shared/ui'
import Feedback from '../../../components/feedback'
import PropTypes from 'prop-types'
import {FormattedMessage} from 'react-intl'

const FreeItemPromoBanner = ({onOpen, promo, setSelectedPromotion, selectedFreeItems}) => {
    const styles = useMultiStyleConfig('FreeItemPromo')
    const {promoBanner} = styles || {}
    const allowedItems = promo?.maxBonusItems || 0
    const selectedCount = (selectedFreeItems?.items || []).reduce(
        (sum, item) => sum + (item.quantity || 1),
        0,
    )

    const handleOpenPromoDrawer = () => {
        setSelectedPromotion({...promo})
        onOpen()
    }

    const MessageComponent = () => {
        return (
            <>
                {allowedItems > 1 &&
                (selectedCount === 0 || selectedFreeItems?.items === undefined) ? (
                    <Flex {...promoBanner?.messageContainer}>
                        <Text {...promoBanner?.bannerText}>
                            <FormattedMessage
                                id="cart.free_item_promo.banner_message_plural"
                                defaultMessage="You got {count} free products!"
                                values={{count: allowedItems}}
                            />
                        </Text>
                        <Button
                            onClick={() => handleOpenPromoDrawer()}
                            variant="text-button"
                            {...promoBanner?.bannerButton}
                        >
                            <FormattedMessage
                                id="cart.free_item_promo.banner_button_plural"
                                defaultMessage="Add them!"
                            />
                        </Button>
                    </Flex>
                ) : allowedItems > 1 && selectedCount > 0 && selectedCount < allowedItems ? (
                    <Flex {...promoBanner?.messageContainer}>
                        <Text {...promoBanner?.bannerText}>
                            {allowedItems - selectedCount === 1 ? (
                                <FormattedMessage
                                    id="cart.free_item.promo.banner_message_plural_intermediate"
                                    defaultMessage="You can add another free product!"
                                />
                            ) : (
                                <FormattedMessage
                                    id="cart.free_item.promo.banner_message_plural_intermediate_count"
                                    defaultMessage="You can add {count} more free products!"
                                    values={{count: allowedItems - selectedCount}}
                                />
                            )}
                        </Text>
                        <Button
                            onClick={() => handleOpenPromoDrawer()}
                            variant="text-button"
                            {...promoBanner?.bannerButton}
                        >
                            <FormattedMessage
                                id="cart.free_item_promo.banner_button"
                                defaultMessage="Add it!"
                            />
                        </Button>
                    </Flex>
                ) : (
                    <Flex {...promoBanner?.messageContainer}>
                        <Text {...promoBanner?.bannerText}>
                            <FormattedMessage
                                id="cart.free_item_promo.banner_message"
                                defaultMessage="You got a free product!"
                            />
                        </Text>
                        <Button
                            onClick={() => handleOpenPromoDrawer()}
                            variant="text-button"
                            {...promoBanner?.bannerButton}
                        >
                            <FormattedMessage
                                id="cart.free_item_promo.banner_button"
                                defaultMessage="Add it!"
                            />
                        </Button>
                    </Flex>
                )}
            </>
        )
    }

    const PromoLabel = () => {
        return (
            <Flex {...promoBanner?.container}>
                <Text {...promoBanner?.labelText}>
                    <FormattedMessage
                        id="carr.free_item_promo.banner_label"
                        defaultMessage="FREE GIFT"
                    />
                </Text>
            </Flex>
        )
    }
    let content = null

    content =
        selectedCount >= allowedItems ? (
            <></>
        ) : (
            <Flex w="100%">
                <Feedback
                    message={<MessageComponent />}
                    variant="freeItemPromo"
                    enableIcon={false}
                    enableCloseIcon={false}
                    promoLabel={<PromoLabel />}
                />
            </Flex>
        )
    return content
}

export default FreeItemPromoBanner

FreeItemPromoBanner.propTypes = {
    onOpen: PropTypes.func,
    allowedItems: PropTypes.number,
    promo: PropTypes.object,
    setSelectedPromotion: PropTypes.func,
    selectedFreeItems: PropTypes.object,
}
